import {
    useContext,
    Fragment,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStepperTextProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    StepperItemPartContentProps
} from "../../type";
import {
    StepperStepStateContext,
    withStepperItemContext
} from "../../context";
import {
    getStepperMeasures,
    getStepperColors
} from "../../stylesheet";
import Text from "../../../text";

const StepperTextContent: FC<StepperItemPartContentProps<IStepperTextProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    item,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        typography,
        iconSizes,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        isHighlighted
    } = useContext(StepperStepStateContext);

    const pointerType = usePointerType();

    const measures = getStepperMeasures({
        orientation: context.orientation,
        isInSheet: context.isInSheet,
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        pointerType,
        typography,
        iconSizes,
        borders,
        spaces
    });

    const currentColors = getStepperColors({
        status: item.status,
        isHighlighted,
        colors
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        measures,
        spaces
    });

    const isHorizontal = context.orientation === "horizontal";

    const renderDefaultLayout = () => {
        return <Fragment>
            <Text
                variant={item.isCurrent ? measures.titleSelectedVariant : measures.titleVariant}
                numberOfLines={isHorizontal ? 1 : undefined}
                customColor={currentColors.titleColor}
                customTheme={customTheme}
                style={stylesheet.title}
            >
                {item.step.title}
            </Text>
            {
                item.description ?
                    <Text
                        customColor={currentColors.descriptionColor}
                        variant={measures.descriptionVariant}
                        numberOfLines={isHorizontal ? 1 : 2}
                        customTheme={customTheme}
                        style={stylesheet.title}
                    >
                        {item.description}
                    </Text>
                :
                    null
            }
        </Fragment>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children ?? renderDefaultLayout()}
    </View>;
};
export default withStepperItemContext("Text", StepperTextContent);
